import createIcon from '../../createIcon';

/**
 * @component @name Php
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNzUgOUgxNC4yNVYxNUgxMi43NVYxMi41SDEwLjc1VjE1SDkuMjVWOUgxMC43NVYxMUgxMi43NVY5Wk03Ljc1IDEwLjVWMTEuNUM3Ljc1IDEyLjMgNy4wNSAxMyA2LjI1IDEzSDQuMjVWMTVIMi43NVY5SDYuMjVDNy4wNSA5IDcuNzUgOS43IDcuNzUgMTAuNVpNNi4yNSAxMC41SDQuMjVWMTEuNUg2LjI1VjEwLjVaTTIxLjI1IDEwLjVWMTEuNUMyMS4yNSAxMi4zIDIwLjU1IDEzIDE5Ljc1IDEzSDE3Ljc1VjE1SDE2LjI1VjlIMTkuNzVDMjAuNTUgOSAyMS4yNSA5LjcgMjEuMjUgMTAuNVpNMTkuNzUgMTAuNUgxNy43NVYxMS41SDE5Ljc1VjEwLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Php = createIcon('Php', [
  [
    'path',
    {
      d: 'M12.75 9H14.25V15H12.75V12.5H10.75V15H9.25V9H10.75V11H12.75V9ZM7.75 10.5V11.5C7.75 12.3 7.05 13 6.25 13H4.25V15H2.75V9H6.25C7.05 9 7.75 9.7 7.75 10.5ZM6.25 10.5H4.25V11.5H6.25V10.5ZM21.25 10.5V11.5C21.25 12.3 20.55 13 19.75 13H17.75V15H16.25V9H19.75C20.55 9 21.25 9.7 21.25 10.5ZM19.75 10.5H17.75V11.5H19.75V10.5Z',
      key: '1r2cby',
    },
  ],
]);

export default Php;
